import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'

const AppSucursalGestion = Loadable(lazy(() => import('./view/Sucursal')))
const AppRolesNuevo = Loadable(lazy(() => import('./view/registro/SucursalRegistro')))
const AppRolesActualizar = Loadable(lazy(() => import('./view/actualizar/SucursalActualizar')))
export const sucursalRoutesMap = {
  gestion: {
    path: '/sucursal/gestion',
    name: 'Sucursales',
    actionSecure: 'administrar',
  },
  nuevo: {
    path: '/sucursal/nuevo',
    name: 'Nueva Sucursal',
  },
  modificar: {
    path: `/sucursal/modificar`,
    name: 'Modificar Sucursal',
  },
}

const sucursalRoutes = [
  {
    path: sucursalRoutesMap.gestion.path,
    element: <AppSucursalGestion />,
    auth: authRoles.admin,
  },
  {
    path: sucursalRoutesMap.nuevo.path,
    element: <AppRolesNuevo />,
    auth: authRoles.admin,
  },
  {
    path: `${sucursalRoutesMap.modificar.path}`,
    element: <AppRolesActualizar />,
    auth: authRoles.admin,
  },
]

export default sucursalRoutes
